import { useTranslation } from "react-i18next";
import { ExtractFnReturnType, QueryConfig } from "../../../lib/react-query";
import { useQuery } from "@tanstack/react-query";
import i18n from "../../../i18n";
import { getFiltersProfessionals } from "../api/getFiltersProfessionals";

type QueryFnType = typeof getFiltersProfessionals;
type UseFiltersOptions = {
    config?: QueryConfig<QueryFnType>;
};

export const useFiltersProfessionals = (config?: UseFiltersOptions) => {
    const { t } = useTranslation(["dashboard"]);
    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        queryKey: ["filtersClaim", i18n.language],
        queryFn: async () => {
            const filters = await getFiltersProfessionals(t);

            return filters;
        }
    });
};